module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_2/2-1-03f260e9fef4133b3e0c885c9a677d5c.png";